/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocPlusIcon20Solid = forwardRef('DocPlusIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 2h3.004v3.748a2.25 2.25 0 0 0 2.25 2.25H16V15a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Zm3.75 8.752a.75.75 0 1 0-1.5 0v1.498H7.752a.75.75 0 0 0 0 1.5H9.25v1.499a.75.75 0 0 0 1.5 0V13.75h1.499a.75.75 0 0 0 0-1.5H10.75v-1.498Z" }),
        React.createElement("path", { d: "m11.504 2.139 4.36 4.359h-3.61a.75.75 0 0 1-.75-.75V2.139Z" })));
});
